import { Box, TextField, Typography, useTheme } from "@mui/material";
import React from "react";
import coverImage from "../../../../media/images/headCover.svg";
import UserRegIcon from "../../../../media/images/icons/userRegister";
import UserLoginIcon from "../../../../media/images/icons/login-newsvg";
import UserProfileIcon from "../../../../media/images/icons/user-profile";
import BigCarIcon from "../../../../media/images/icons/bigCar";
import SearchIcon from "../../../../media/images/icons/search";
import { theme } from "../../../../themes";
import { Link } from "react-router-dom";
import FaqCard from "./FaqCard";
export default function GuideMain() {
  const theme = useTheme();

  const guids = [
    {
      path: "signup-guides",
      title: "راهنما ثبت‌نام",
      icon: <UserRegIcon color={theme.palette.secondary.dark} />,
    },
    {
      path: "login",
      title: "راهنما ورود",
      icon: <UserLoginIcon color={theme.palette.secondary.dark} />,
    },
    {
      path: "condignment-owner",
      title: "راهنمای صاحبین بار",
      icon: <UserProfileIcon color={theme.palette.secondary.dark} />,
    },
    {
      path: "drivers",
      title: "راهنمای رانندگان",
      icon: <BigCarIcon color={theme.palette.secondary.dark} />,
    },
  ];

  return (
    <>
      <Box
        sx={{
          backgroundImage: `
          linear-gradient(0deg, rgba(211, 134, 39, 0.97) 46.43%, rgba(239, 183, 114, 0.81) 135.27%),
            url(${coverImage})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          flexDirection: "column",
          borderRadius: "20px",
          justifyContent: "end",
          paddingX: "16px",
          boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <Typography
          sx={{
            marginTop: "60px",
            fontSize: "22px",
            fontWeight: "900",
            color: "background.default",
          }}
        >
          راهنمای بازارگاه{" "}
        </Typography>
        <Typography
          sx={{
            marginBottom: "16px",
            color: "background.default",
          }}
        >
          راهنمای جامع خدمات و سوالات متداول کاربران{" "}
        </Typography>
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          border: "1px solid gray",
          paddingX: "8px",
          borderRadius: "8px",
        }}
      >
        <TextField
          placeholder="سوال یا موضوع را جست‌وجو کنید "
          size="small"
          sx={{
            flex: 1,
            "& .MuiOutlinedInput-notchedOutline": {
              border: "none !important",
              outline: "none !important",
            },
            "& .MuiInputBase-input": {
              border: "none !important",
              outline: "none !important",
            },
            "& .MuiInputBase-root": {
              border: "none !important",
              outline: "none !important",
            },
            border: "none",
          }}
        />
        <SearchIcon color={theme.palette.primary.main} />
      </Box>
      <Typography
        sx={{
          textAlign: "center",
        }}
      >
        همچنین می‌توانید از دسته‌بندی‌های زیر انتخاب کنید:
      </Typography>

      <Box
        sx={{
          display: "flex",
          // alignItems: "center",
          gap: "16px",
        }}
      >
        {guids.map((item) => (
          <Link
            to={item.path}
            style={{
              borderStyle: "solid",
              borderWidth: "1px",
              borderColor: theme.palette.secondary.dark,
              boxShadow: "0px 4px 6px 0px rgba(0, 0, 0, 0.20)",
              display: "flex",
              flexDirection: "column",
              flex: 1,
              padding: "8px 8px 8px 8px",

              borderRadius: "16px",
              justifyContent: "center",
              alignItems: "center",

              gap: "10px",

              backgroundColor: theme.palette.background.default,
            }}
          >
            {item.icon}
            <Typography
              sx={{
                textAlign: "center",
                color: "secondary.dark",
              }}
            >
              {item.title}
            </Typography>
          </Link>
        ))}
      </Box>

      <Box
        sx={{
          marginTop: "16px",
        }}
      >
        <Typography
          sx={{
            color: "primary.main",
            fontSize: "16px",
            fontWeight: 600,
            textAlign: "center",
          }}
        >
          سوالات متداول:
        </Typography>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "12px",
            marginTop: "8px",
          }}
        >
          <FaqCard />
          <FaqCard />
          <FaqCard />
        </Box>
      </Box>
    </>
  );
}
